/**
 * Common pollutants from the EU Industrial Emissions Directive (IED) and
 * European Pollutant Release and Transfer Register (E-PRTR) regulation.
 *
 * Norwegian companies report emissions of these pollutants to the
 * Norwegian Environment Agency (Miljødirektoratet). The Norwegian names
 * follow the conventions used in official Norwegian environmental reporting.
 *
 * @see https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32006R0166 E-PRTR Regulation
 * @see https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32010L0075 IED Directive
 */

/** Pollutant codes mapped to Norwegian pollutant names. */
export const pollutantsNb: Record<string, string> = {
  SO2: "Svoveldioksid",
  NOx: "Nitrogenoksider",
  CO: "Karbonmonoksid",
  CO2: "Karbondioksid",
  CH4: "Metan",
  N2O: "Dinitrogenoksid",
  NH3: "Ammoniakk",
  NMVOC: "Flyktige organiske forbindelser",
  PM10: "Svevestøv PM10",
  "PM2.5": "Svevestøv PM2.5",
  Pb: "Bly",
  Hg: "Kvikksølv",
  Cd: "Kadmium",
  Ni: "Nikkel",
  As: "Arsen",
  Cr: "Krom",
  Cu: "Kobber",
  Zn: "Sink",
  HCl: "Hydrogenklorid",
  HF: "Hydrogenfluorid",
  PCB: "Polyklorerte bifenyler",
  "PCDD/F": "Dioksiner og furaner",
  PAH: "Polysykliske aromatiske hydrokarboner",
  Benzene: "Benzen",
  Chlorides: "Klorider",
  Cyanides: "Cyanider",
  Fluorides: "Fluorider",
  Phenols: "Fenoler",
  TOC: "Totalt organisk karbon",
  "N-total": "Nitrogen, totalt",
  "P-total": "Fosfor, totalt",
}

/** Sorted array of { code, name } for use in dropdowns. */
export const pollutantOptionsNb: Array<{ code: string; name: string }> = Object.entries(pollutantsNb)
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name, "nb"))
